import React, { useState } from 'react';

const TransferForm = ({ formData, employees = [], currentUserId, onChange }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const filteredEmployees = employees.filter(emp => {
        const empId = emp._id || emp.id;
        return empId && empId.toString() !== (currentUserId ? currentUserId.toString() : '');
    });

    const selectStyle = {
        width: '100%',
        maxWidth: '100%',
        padding: '10px 12px',
        border: '1px solid #e2e8f0',
        borderRadius: '6px',
        fontSize: '13px',
        fontFamily: 'inherit',
        backgroundColor: 'white',
        cursor: 'pointer',
        position: 'relative'
    };

    const dropdownMenuStyle = {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        backgroundColor: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '6px',
        marginTop: '4px',
        maxHeight: '200px',
        overflowY: 'auto',
        zIndex: 1000,
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
    };

    const optionStyle = {
        padding: '8px 12px',
        cursor: 'pointer',
        fontSize: '13px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    };

    const selectedEmployee = filteredEmployees.find(emp => (emp._id || emp.id) === formData.transferTo);
    const selectedText = selectedEmployee ? selectedEmployee.name : '-- Select Employee or Admin --';

    const handleSelectEmployee = (empId) => {
        onChange({
            target: { name: 'transferTo', value: empId }
        });
        setIsDropdownOpen(false);
    };

    return (
        <div className="transfer-form">
            <div className="form-group" style={{ marginBottom: '20px' }}>
                <label htmlFor="transferTo">Transfer To (Employee or Admin) * ({filteredEmployees.length} available)</label>
                <div style={{ position: 'relative' }}>
                    <div
                        id="transferTo"
                        style={{
                            ...selectStyle,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            borderColor: isDropdownOpen ? '#3182ce' : '#e2e8f0'
                        }}
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    >
                        <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {selectedText}
                        </span>
                        <span style={{ marginLeft: '8px', fontSize: '12px' }}>▼</span>
                    </div>

                    {isDropdownOpen && (
                        <div style={dropdownMenuStyle}>
                            <div
                                style={{ ...optionStyle, backgroundColor: '#f7fafc' }}
                                onClick={() => {
                                    onChange({ target: { name: 'transferTo', value: '' } });
                                    setIsDropdownOpen(false);
                                }}
                            >
                                -- Select Employee or Admin --
                            </div>
                            {filteredEmployees.length > 0 ? (
                                filteredEmployees.map(emp => (
                                    <div
                                        key={emp._id || emp.id}
                                        style={{
                                            ...optionStyle,
                                            backgroundColor: (emp._id || emp.id) === formData.transferTo ? '#ebf8ff' : 'white'
                                        }}
                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
                                        onMouseLeave={(e) => e.target.style.backgroundColor = (emp._id || emp.id) === formData.transferTo ? '#ebf8ff' : 'white'}
                                        onClick={() => handleSelectEmployee(emp._id || emp.id)}
                                        title={`${emp.name} ${emp.email ? `(${emp.email})` : ''}`}
                                    >
                                        {emp.name} {emp.role === 'admin' ? '[Admin]' : ''} {emp.email ? `(${emp.email})` : ''}
                                    </div>
                                ))
                            ) : (
                                <div style={{ ...optionStyle, color: '#718096' }}>
                                    No other users available
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            <div className="form-group" style={{ marginBottom: '20px' }}>
                <label htmlFor="notes">Notes / Condition</label>
                <textarea
                    id="notes"
                    name="notes"
                    value={formData.notes}
                    onChange={onChange}
                    placeholder="Add any notes about this transfer (e.g., condition of asset, special instructions)"
                    style={{
                        width: '100%',
                        padding: '10px 12px',
                        border: '1px solid #e2e8f0',
                        borderRadius: '6px',
                        fontSize: '13px',
                        fontFamily: 'inherit',
                        minHeight: '120px',
                        resize: 'vertical'
                    }}
                />
                <small style={{ color: '#718096', fontSize: '11px', marginTop: '4px', display: 'block' }}>
                    Optional - Add any additional information about the transfer
                </small>
            </div>
        </div>
    );
};

export default TransferForm;
